<div *ngIf="!PaginaCitas(); then home; else citaprevia"></div>

<ng-template #home>
  <div class="home-cita-previa">
    <header class="cabecera">
      <i
        class="btn-retroceder fas fa-angle-left"
        *ngIf="oRouter.url !== '/' && oRouter.url !== '/citas'"
        [routerLink]="['/']"
      ></i>
      <img [alt]="getImagenAlt()" [src]="getImagenLogo()" class="logo" />
      <div class="wrapper_header">
        <h1 class="title_header">Cita previa</h1>
        <span class="cliente">{{ Cliente() }}</span>
      </div>
    </header>

    <div class="capa-cita">
      <div *ngIf="getClienteLogado(); then navegar; else pagerror"></div>
      <ng-template #navegar>
        <router-outlet></router-outlet>
      </ng-template>
      <ng-template #pagerror>
        <app-cliente-no-valido></app-cliente-no-valido>
      </ng-template>

      <div class="footer-citaprevia">
        <p>Copyright © {{ getYear() }} ATM Maggioli, S.L. | v{{ sVersion }}</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #citaprevia>
  <app-pedir-cita></app-pedir-cita>
</ng-template>
